import { VisitsFilterKeysWithoutDate } from 'models'

import { BotDetectionUrlKey, IdentificationUrlKeys, Platform, SmartSignalUrlKey } from '../types'

export const smartSignalFilterPlatformMap = new Map<Platform, SmartSignalUrlKey[]>([
  [
    Platform.Universal,
    [
      IdentificationUrlKeys.MinSuspectScore,
      IdentificationUrlKeys.IpBlocklist,
      IdentificationUrlKeys.ResidentialProxy,
      IdentificationUrlKeys.MitmAttack,
      IdentificationUrlKeys.Tor,
      IdentificationUrlKeys.DeveloperTools,
    ],
  ],
  [
    Platform.Web,
    [
      IdentificationUrlKeys.Incognito,
      IdentificationUrlKeys.Vpn,
      IdentificationUrlKeys.BrowserTampering,
      IdentificationUrlKeys.VirtualMachine,
      IdentificationUrlKeys.PrivacySettings,
      IdentificationUrlKeys.DeviceRarity,
    ],
  ],
  [
    Platform.Mobile,
    [
      IdentificationUrlKeys.Emulator,
      IdentificationUrlKeys.Simulator,
      IdentificationUrlKeys.ClonedApp,
      IdentificationUrlKeys.LocationSpoofing,
      IdentificationUrlKeys.RootedDevice,
      IdentificationUrlKeys.JailbrokenDevice,
      IdentificationUrlKeys.Frida,
      IdentificationUrlKeys.ActiveCall,
    ],
  ],
])

export const allSmartSignalFilterValues = [...smartSignalFilterPlatformMap.values()].flat()
export const allSmartSignalFilterSet = new Set(allSmartSignalFilterValues)

export const botDetectionFilterKeys: BotDetectionUrlKey[] = [
  IdentificationUrlKeys.Bot,
  IdentificationUrlKeys.BotName,
  IdentificationUrlKeys.BotCategory,
  IdentificationUrlKeys.BotProvider,
  IdentificationUrlKeys.BotIdentity,
  IdentificationUrlKeys.BotConfidence,
]
export const botDetectionFilterSet = new Set(botDetectionFilterKeys)

export const visitFilterLabelMap: Record<VisitsFilterKeysWithoutDate, string> = {
  [IdentificationUrlKeys.RequestId]: 'Event ID',
  [IdentificationUrlKeys.VisitorId]: 'Visitor ID',
  [IdentificationUrlKeys.ProximityId]: 'Proximity ID',
  [IdentificationUrlKeys.IpAddress]: 'IP Address',
  [IdentificationUrlKeys.Url]: 'URL',
  [IdentificationUrlKeys.LinkedId]: 'Linked ID',
  [IdentificationUrlKeys.Origin]: 'Origin',
  [IdentificationUrlKeys.Asn]: 'ASN',
  [IdentificationUrlKeys.Environment]: 'Environment',
  [IdentificationUrlKeys.SdkPlatform]: 'SDK Platform',
  [IdentificationUrlKeys.SdkVersion]: 'SDK Version',
  [IdentificationUrlKeys.Bot]: 'Bot',
  [IdentificationUrlKeys.BotName]: 'Bot name',
  [IdentificationUrlKeys.BotCategory]: 'Category',
  [IdentificationUrlKeys.BotProvider]: 'Provider',
  [IdentificationUrlKeys.BotIdentity]: 'Identity',
  [IdentificationUrlKeys.BotConfidence]: 'Confidence',
  [IdentificationUrlKeys.Vpn]: 'VPN',
  [IdentificationUrlKeys.IpBlocklist]: 'IP Blocklist',
  [IdentificationUrlKeys.ResidentialProxy]: 'Residential Proxy',
  [IdentificationUrlKeys.Incognito]: 'Incognito Mode',
  [IdentificationUrlKeys.BrowserTampering]: 'Browser Tampering',
  [IdentificationUrlKeys.VirtualMachine]: 'Virtual Machine',
  [IdentificationUrlKeys.PrivacySettings]: 'Privacy Settings',
  [IdentificationUrlKeys.DeveloperTools]: 'Developer Tools',
  [IdentificationUrlKeys.Emulator]: 'Android Emulator',
  [IdentificationUrlKeys.Simulator]: 'iOS Simulator',
  [IdentificationUrlKeys.ClonedApp]: 'Cloned App',
  [IdentificationUrlKeys.LocationSpoofing]: 'Location Spoofing',
  [IdentificationUrlKeys.MitmAttack]: 'MITM Attack',
  [IdentificationUrlKeys.DeviceRarity]: 'Rare device',
  [IdentificationUrlKeys.ActiveCall]: 'Active Call',
  [IdentificationUrlKeys.RootedDevice]: 'Rooted Device',
  [IdentificationUrlKeys.JailbrokenDevice]: 'Jailbroken Device',
  [IdentificationUrlKeys.Frida]: 'Frida Detected',
  [IdentificationUrlKeys.MinSuspectScore]: 'Minimum Suspect Score',
  [IdentificationUrlKeys.Tor]: 'Tor',
  [IdentificationUrlKeys.HighRecallId]: 'High Recall ID',
}
